fragment PrintHandlingChargeFragment on PrintHandlingCharge {
    id
    code
    charge_gross
    charge_net
}